import { createSelector } from "reselect";

import { TableColumnMeta } from "ds/components/Table/types";

import { TableColumnsState, TableSettingsConfig } from "./types";

export const selectVisibleColumns = createSelector(
  (state: TableColumnsState) => state.columnsState,
  (state: TableColumnsState) => state.columnsOrder,
  (columnsState, columnsOrder): TableColumnMeta[] => {
    return columnsOrder.visible.reduce<TableColumnMeta[]>((acc, columnId) => {
      const column = columnsState[columnId];
      if (column) {
        acc.push(column);
      }
      return acc;
    }, []);
  }
);

export const selectTableSettingsConfig = createSelector(
  (state: Pick<TableColumnsState, "columnsState" | "columnsOrder">) => state.columnsState,
  (state: Pick<TableColumnsState, "columnsState" | "columnsOrder">) => state.columnsOrder,
  (columnsState, columnsOrder): TableSettingsConfig => {
    return {
      visibleColumns: columnsOrder.visible,
      hiddenColumns: columnsOrder.hidden,
      staticColumns: Object.keys(columnsState).filter(
        (columnId) => !columnsState[columnId].canHide
      ),
      nonConfigurableColumns: Object.keys(columnsState).filter(
        (columnId) => columnsState[columnId].configurable === false
      ),
    };
  }
);
